export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "Jun",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const yearsList = [
  "2023",
  "2024",
  "2025",
  "2026",
  "2027",
  "2028",
  "2029",
  "2030",
];

export const chartColorList = [
  "#00E6f5",
  "#0094A4",
  "#01657D",
  "#82E9FC",
  "#01A0C4",
  "#00606b",
  "#00C5DA",
  "#003E45",
]

export const MAX_ACTIONS_POINTS = 500;
